import styled, { css } from 'styled-components';
import { Pagination } from '@material-ui/lab';

interface PaginationContainerProps {
  $forGrid?: boolean;
}

export const PaginationContainer = styled(Pagination)<PaginationContainerProps>`
  ${(props) =>
    props.$forGrid &&
    css`
      flex-grow: 1;
    `}

  & .MuiPagination-ul {
    justify-content: center;
    padding: ${(props) => (props.$forGrid ? '12px 2px 12px 2px' : '22px 2px 0 2px')};
  }
`;
